module.exports = __webpack_public_path__ + "img/icon_ai_image.da2a6058.svg";